// import 'firebase/database'
// import firebase from 'firebase/app'
// import 'firebase/firestore'

// const FirebaseConfig = {
//   apiKey: 'AIzaSyB9sr_DDLn9HXcRlghH5QzTQecV61bt8v0',
//   authDomain: 'sinkr-c127b.firebaseapp.com',
//   databaseURL: 'https://sinkr-c127b.firebaseio.com',
//   projectId: 'sinkr-c127b',
//   // storageBucket: 'sinkr-c127b.appspot.com',
//   // messagingSenderId: '413605983486',
//   appId: '1:413605983486:web:9941c680ff6716de5b61af'
//   // measurementId: 'G-G5YY134VSE'
// }

// const firebaseApp = firebase.initializeApp(FirebaseConfig)
// const db = firebaseApp.firestore()

const db = {}

export {
  db
}



// WEBPACK FOOTER //
// ./src/communication/FirebaseConfig.js